import { defineComponent } from 'vue';
import BaseIcon from '../atoms/BaseIcon.vue';
export default defineComponent({
    name: 'DialogComponent',
    components: { BaseIcon },
    props: { open: Boolean },
    emits: ['close'],
});
